import subcategorySymbols from "../symbols/subcategories";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function SubcategorySymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case subcategorySymbols.GET_SUBCATEGORIES:
      return { ...state, loading: true, error: false };
    case subcategorySymbols.GET_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case subcategorySymbols.GET_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case subcategorySymbols.CLEAR_GET_SUBCATEGORIES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
